import { render, staticRenderFns } from "./LeaveLimitSummaryWarning.vue?vue&type=template&id=72f5e43c"
import script from "./LeaveLimitSummaryWarning.vue?vue&type=script&lang=js"
export * from "./LeaveLimitSummaryWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports